module.exports = __webpack_public_path__ + "img/91096.55f59507.svg";